export enum LogoDropdownKey {
  DatasetManagement = 'DatasetManagement',
  TelemetryDashboard = 'TelemetryDashboard',
  Rbac = 'Rbac',
  DataMarketPlace = 'DataMarketPlace',
}
